import DOMPurify from 'dompurify';
import type { MessageStatus } from '@/types/notifications';

// Чистые view-хелперы уведомлений: цвет по статусу, безопасный рендер тела (HTML), формат даты.

let hookRegistered = false;

// Все ссылки в теле уведомления открываем в новой вкладке безопасно.
function ensureLinkHook(): void {
  if (hookRegistered) {
    return;
  }
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node instanceof Element && node.tagName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
  hookRegistered = true;
}

const ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'u', 'br', 'p', 'span', 'a', 'ul', 'ol', 'li'];
const ALLOWED_ATTR = ['href'];

/**
 * Очистить HTML тела уведомления от XSS (бэк рендерит .ftl в HTML). Разрешён узкий набор тегов;
 * `<script>`, обработчики событий и опасные атрибуты вырезаются. Пусто → ''.
 */
export function sanitizeNotificationBody(html: string | undefined): string {
  if (!html) {
    return '';
  }
  ensureLinkHook();
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
}

/** Mantine-цвет по статусу сообщения (бейдж/иконка). */
export function statusColor(status: MessageStatus | undefined): string {
  switch (status) {
    case 'SUCCESS':
      return 'lime';
    case 'ERROR':
      return 'red';
    case 'NOTIFY':
      return 'brand';
    default:
      return 'gray';
  }
}

// Один форматтер на модуль (конструктор Intl.DateTimeFormat дорогой — не пересоздаём на каждый элемент).
const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
  day: 'numeric',
  month: 'long',
  hour: '2-digit',
  minute: '2-digit',
});

/** Дата уведомления в локали ru-RU («18 июня, 14:30»). Невалидная/пустая → ''. */
export function formatNotificationDate(iso: string | undefined): string {
  if (!iso) {
    return '';
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return dateFormatter.format(date);
}
